import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("ol", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.candidates, (c) => {
      return (_openBlock(), _createElementBlock("li", { key: c }, _toDisplayString(c), 1 /* TEXT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}